import request from '@/utils/request';
export function detail(query) {
  return request({
      url: '/logisticsExpressage/detail',
      method: 'get',
      params: query
    })
}

export function getQrcode(data) {
  return request({
      url: `/wxInterface/getQrCode`,
      method: 'get',
      responseType: 'blob',
      params: data
  })
}
export function getDefault(query) {
  return request({
      url: '/logisticsAddressBook/getDefault?dataType=1',
      method: 'get',
      params: query
    })
}